.layout-banner {
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-radius: 4px;
  margin: 0.5% 0.8% 0 0.8%;
  width: 98.4%;
  z-index: 1000;
}

.layout-banner-message {
  flex-grow: 1;
}

.layout-banner-message .message-content {
  display: flex;
  align-items: center;
}

.layout-banner-message .message-content p {
  margin: 0;
  margin-left: 10px;
}

.dark-theme .layout-banner {
  background-color: #e6e6e6;
  color: #262626;
}
.dark-theme .layout-banner .layout-banner-button {
  background: #36f !important;
  color: white;
}

.light-theme .layout-banner {
  background-color: white;
  color: black;
  border: 2px solid #3b6bf6;
}
.light-theme .layout-banner-button {
  background: #d9d9d9;
  color: #666;
  padding: 7px 12px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvU2l0ZUFkbWluVmlldy9MYXlvdXRWaWV3L3dpZGdldHMvUHJpdmF0ZVBhZ2VCYW5uZXIiLCJzb3VyY2VzIjpbIlByaXZhdGVQYWdlQmFubmVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFJQTtFQUNFO0VBQ0E7O0FBRUY7RUFDRTtFQUNBOzs7QUFLRjtFQUNFO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5sYXlvdXQtYmFubmVyIHtcbiAgcGFkZGluZzogMC41cmVtIDFyZW07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIG1hcmdpbjogMC41JSAwLjglIDAgMC44JTtcbiAgd2lkdGg6IDk4LjQlO1xuICB6LWluZGV4OiAxMDAwO1xufVxuXG4ubGF5b3V0LWJhbm5lci1tZXNzYWdlIHtcbiAgZmxleC1ncm93OiAxO1xufVxuXG4ubGF5b3V0LWJhbm5lci1tZXNzYWdlIC5tZXNzYWdlLWNvbnRlbnQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4ubGF5b3V0LWJhbm5lci1tZXNzYWdlIC5tZXNzYWdlLWNvbnRlbnQgcCB7XG4gIG1hcmdpbjogMDtcbiAgbWFyZ2luLWxlZnQ6IDEwcHg7XG59XG5cbi5kYXJrLXRoZW1lIHtcbiAgLmxheW91dC1iYW5uZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNlNmU2ZTY7XG4gICAgY29sb3I6ICMyNjI2MjY7XG4gIH1cbiAgLmxheW91dC1iYW5uZXIgLmxheW91dC1iYW5uZXItYnV0dG9uIHtcbiAgICBiYWNrZ3JvdW5kOiAjMzZmICFpbXBvcnRhbnQ7XG4gICAgY29sb3I6IHdoaXRlO1xuICB9XG59XG5cbi5saWdodC10aGVtZSB7XG4gIC5sYXlvdXQtYmFubmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTtcbiAgICBjb2xvcjogYmxhY2s7XG4gICAgYm9yZGVyOiAycHggc29saWQgIzNiNmJmNjtcbiAgfVxuICAubGF5b3V0LWJhbm5lci1idXR0b24ge1xuICAgIGJhY2tncm91bmQ6ICNkOWQ5ZDk7XG4gICAgY29sb3I6ICM2NjY7XG4gICAgcGFkZGluZzogN3B4IDEycHg7XG4gIH1cbn1cbiJdfQ== */